import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { InputSelectDirective } from '../input/input-select.directive';

let instanceCount = 0;

export interface SelectOption {
  label: string;
  value: string | number;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-dashboard-widget-select',
  imports: [FormsModule, InputSelectDirective],
  styleUrl: './dashboard-widget-select.component.scss',
  template: `
    <label [attr.for]="elementId">{{ label() }}</label>
    <select [id]="elementId" [(ngModel)]="model" sbInput>
      @for (option of options(); track option.value) {
        <option [ngValue]="option.value">{{ option.label }}</option>
      }
    </select>
  `,
})
export class DashboardWidgetSelectComponent {
  /**
   * Auto generated unique field id for select input
   */
  elementId = `dashboard-widget-nr-${instanceCount++}`;

  /**
   * value to set for select input
   */
  model = model<string | number>();

  /**
   * Label for select input field
   */
  label = input<string>();

  /**
   * options for the select dropdown
   */
  options = input<SelectOption[]>();
}
